import React from 'react';
import type { FC } from 'react';

interface UncheckIconProps {
    className?: string;
    size?: number;
    title?: string;
}

export const UncheckIcon: FC<UncheckIconProps> = ({ className, size = 18, title = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>{title}</title>

            <rect x="4" y="4" width="12" height="12" rx="1" stroke="#B4B4B4" strokeLinejoin="round" />
        </svg>
    );
};
